// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"101":"13572559","135":"9f8f1d47","274":"95c5bce8"}[chunkId] + ".css";
};